import { api } from "services"

export async function getClients() {
  const { data } = await api.get("/clients?asList=1")
  
  return data
}